import DomainSearchStartStrip from './DomainSearchStartStrip';

export default DomainSearchStartStrip;
